import React from "react";

const TopBar = () => (
  <div className="vd-topbar">
    <div className="container d-flex flex-wrap justify-content-between gap-2">
      <span>
        Built in India for Indian courts, tribunals and tax practice · Case law
        in partnership with <strong>TIOL</strong>
      </span>
      <span className="d-flex gap-3">
        <a href="/#contact">Talk to sales</a>
        <a href="/#security">Trust centre</a>
      </span>
    </div>
  </div>
);

export default TopBar;
